import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { AppsColumnSelectionRequestDto } from "app/pages/sales-intelligence/modules/apps-search/types/dto";
import type { AppOperatingSystem } from "app/pages/sales-intelligence/modules/apps-search-filters/types/commonFiltersDto";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { assertDefined } from "app/pages/sales-intelligence/utils/errors/assertions";
import { trackError } from "app/pages/sales-intelligence/utils/errors/tracking";
import { SiError, errorCategoryMap } from "app/pages/sales-intelligence/utils/errors/types";

import { appsSearchQueryKeys } from "../key-factory/factory";

export const useAppsColumnSelectionMutation = (appOs: AppOperatingSystem | undefined) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: appsSearchQueryKeys.columnSelectionMutation(),
        mutationFn(dto: AppsColumnSelectionRequestDto) {
            assertDefined(appOs, { name: "appOs" });

            return salesApiService.appsSearch.columnConfig.saveColumnSelection(appOs, dto);
        },
        onError(error) {
            trackError(
                new SiError(
                    "Failed to save column selection",
                    {
                        category: errorCategoryMap.api,
                        operation: "saveColumnSelection",
                    },
                    { cause: error },
                ),
            );
        },
        onSuccess() {
            void queryClient.invalidateQueries({
                queryKey: appsSearchQueryKeys.columnConfig(appOs),
            });

            void queryClient.resetQueries({
                queryKey: appsSearchQueryKeys.tableData(),
            });
        },
    });
};
